import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';

@Component({
  selector: 'app-message',
  standalone: true,
  imports: [RouterModule, StoryblokDirective],
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
  animations: [
    trigger('changeAnimation', [
      state(
        'initial',
        style({
          opacity: 1,
        })
      ),
      state(
        'changed',
        style({
          opacity: 0,
        })
      ),
      transition('initial => changed', [animate('0.3s')]),
      transition('changed => initial', [animate('0.3s')]),
    ]),
  ],
})
export class MessageComponent implements OnChanges {
  @Input() message!: string;
  @Input() colour!: { color: string };
  @Input() background!: { color: string };
  @Input() _editable!: string;

  @Input() _uid!: string;
  @Input() component!: string;

  animationState = 'initial';
  _message?: string;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges() {
    if (this._message) {
      this.animationState = 'changed';
    }
    if (this.colour?.color) {
      this.renderer.setStyle(this.el.nativeElement, 'color', this.colour.color);
    }
    if (this.background?.color) {
      this.renderer.setStyle(
        this.el.nativeElement,
        'background',
        this.background.color
      );
    }
    if (!this._message) {
      this._message = this.message;
      return;
    }
    setTimeout(() => {
      this._message = structuredClone(this.message);
      setTimeout(() => {
        this.animationState = 'initial';
      }, 300);
    }, 600);
  }

  clickedInside($event: Event) {
    $event.preventDefault();
    $event.stopPropagation();
  }
}
